/**
 * 订单管理 订单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客诉记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <!-- <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单号:">
        <el-input size="small" v-model="formInline.orderNo" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input size="small" v-model="formInline.userName" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="支付类型:">
        <el-select size="small" v-model="formInline.payType" placeholder="请选择">
          <el-option v-for="types in payType" :label="types.key" :value="types.value" :key="types.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="套餐查询:">
        <el-select v-model="formInline.rtid" size="small" style="width: 100%;" placeholder="请选择套餐">
          <el-option
            v-for="item in listDataArr"
            :key="item.id"
            :label="item.title"
            align="center"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付状态:">
        <el-select size="small" v-model="formInline.payStatus" placeholder="请选择">
          <el-option v-for="types in payway" :label="types.key" :value="types.value" :key="types.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form> -->
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" label="ID" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="payOrderId" label="支付订单号" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="orderNo" label="订单号" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="statusName" label="状态" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="replayResult" label="答复状态" width="120" show-overflow-tooltip>
    </el-table-column>

      <el-table-column align="center" label="操作" fixed="right"  min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" @click="handleReply(scope.$index, scope.row)">答复</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" @click='closeDialog("edit")'>
      <div>
        <div style="display: flex;">
        <div style="width: 50px;">结果：</div> <div style="width:calc( 100% - 50px )">{{ editForm.resultCont }}</div>
      </div>
      <div style="display: flex;">
        <div style="width: 50px;">备注：</div> <div style="width:calc( 100% - 50px )">{{ editForm.remark }}</div>
      </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>关闭</el-button>

      </div>
    </el-dialog>
    <el-dialog title="答复" :visible.sync="editFormReply" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" @click='closeDialog("edit")'>
        <el-form label-width="60px" :model="replyData" :rules="rules" ref="replyData">
        <el-form-item label="答复:" prop="Reply">
          <el-input size="small" v-model="replyData.Reply" auto-complete="off" placeholder="请输入答复内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>关闭</el-button>
        <el-button v-if="editFormReply" size="mini" type="danger" @click="deleteUser('replyData')">回复</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { complaintsPage, userRefunds, vipTypeReport,complaintsReplay} from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        replyData:{ Reply:''},
        editFormReply:false,
      loading: false, //是显示加载
      listDataArr: [],
      editFormVisible: false, //控制编辑页面显示与隐藏
      money: 0,
      title: '详情',
      payType: [
        { key: '全部', value: null },
        { key: '支付宝', value: 0 },
        { key: '微信', value: 1 },
        // { key: '小程序-Android', value: 3 },
        // { key: '小程序-ios', value: 4 },
        // { key: '幻影分身', value: 5 },
      ],
      payway: [
        { key: '全部', value: null },
        { key: '支付成功', value: 1 },
        { key: '待支付', value: 0 },
        { key: '支付失败', value: -1 },
        { key: '支付失效', value: -2 },
        { key: '已拉黑', value: -3 },
        { key: '已退款', value: -4 },
      ],
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      rules: {
        Reply: [
          { required: true, message: '请输入答复内容', trigger: 'blur' }
        ]
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        // machineNo: '',
        // orderNo: '',
        // userName: "",
        // transId: '',
        // rtid: null,
        // payType: null,
        // payStatus: null,
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    vipTypeReport({startRq: '2024-05-01', endRq: '2024-05-21'}).then(res => {
      if(res.code == 0){
        this.listDataArr = [{title: '全部', id: null },...res.data.list]
      }
    })
    console.log(this.$route, 'route')
  },
  mounted(){
    if(this.$route.query && this.$route.query.orderNum){
      this.formInline.orderNo = this.$route.query.orderNum
    }
    if(this.$route.query && this.$route.query.userName){
      this.formInline.userName = this.$route.query.userName
    }
    if(this.$route.query && this.$route.query.taoCan){
      this.formInline.rtid = this.$route.query.taoCan * 1
    }
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */

       complaintsPage(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.complaintList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNo +1
            this.pageparm.pageSize = res.data.pageSize
            this.pageparm.total = res.data.totalSize
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      this.money = this.editForm.goodsMoney * 1
    },

    handleReply(index, row){
        // if(row.replayResult!='答复'){
            this.editFormReply = true
            this.replyData = row
        // }else{
        //     this.$message.info('已答复！')
        // }

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 退款
    deleteUser(row) {
        this.$refs[row].validate(valid => {
        if (valid) {
            console.log(1515)
            complaintsReplay({id:this.replyData.id,replay:this.replyData.Reply}).then(res => {
              this.editFormReply = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '答复成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormReply = false
              this.loading = false
              this.$message.error('答复失败请重新提交！')
            })

        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/complaints/page.vue